import { render, staticRenderFns } from "./ThirdLevel.vue?vue&type=template&id=5cdfefd0"
import script from "./ThirdLevel.vue?vue&type=script&lang=js"
export * from "./ThirdLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports